module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAAFAAAAAAV6Uf1AAAAqElEQVQ4EWNk8N3myfDv/ywGhv8yDGQBxicMTIxpjAzeWx+TbwjMZsYnTJQbAjLsvwzQIOoAqhnEguEeFkY9ho3elzHEkQX8t+oy/Pl/CVkI06A/DJUMPltvISvCYP9hUEMXwzSI4X8kw390ZYT5AxRGWMIG5lZMr+ELIyxhg9ugoRFGeMIGt9ewhRGesMFt0ECHEdUSJNAgYAlHMQAVbMBikjLDIEUtAKXwN18vSxxdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/report-icon.png
// module id = wfvB
// module chunks = 1